const DOMPurify = require("dompurify");

class SafeHtmlElement extends HTMLElement {
  static get observedAttributes() {
    return ["content"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  render() {
    const content = this.getAttribute("content") || "";
    if (!DOMPurify.isSupported) {
      return;
    }
    this.innerHTML = DOMPurify.sanitize(content);
    this.querySelectorAll("span.mention").forEach((el) => {
      el.style.fontWeight = "bold";
    });
  }
}

const SafeHtmlPort = {
  add: function () {
    if (typeof customElements !== "undefined" && !customElements.get("safe-html")) {
      customElements.define("safe-html", SafeHtmlElement);
    }
  },
};

module.exports = SafeHtmlPort;
